// This is sandbox page to run anyting you want

import Button from '@mui/material/Button'
import {api2Endpoint} from 'app/config/apiConfig'
import axios from 'axios'
import GanttChart from './gantt-chart'

// const resAffindaJohnLaylor = JSON.parse(ResAffindaJohnLaylor.toString())
// const resAffindaPatriciaCulligan = JSON.parse(ResAffindaPatriciaCulligan.toString())
// const resAlexPjCulligan = JSON.parse(ResAlexPjCulligan.toString())
// const resAlexJohnP = JSON.parse(ResAlexJohnP.toString())

export default function SandBox() {
  const sendTestEmail = async () => {
    const res = await axios.get(api2Endpoint('std/user/testemail'))
  }
  return (
    <>
      <Button onClick={() => sendTestEmail()}>Send Test Email</Button>
      <GanttChart />
    </>
  )
}
